import React, { useEffect, useState } from 'react'
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from '@/Components/ui/breadcrumb'
import { useLocation, useParams, Link } from 'react-router-dom'
import { capitalizeFirstChar } from '@/utils/helper'

const STATIC_SETUP_PATHS = [
    'page-permissions',
    'payor-type',
    'hchb-payor-type',
    'mitem-payor-type',
    'assessment-type',
    'section',
    'mitem',
    'hold-reason',
    'technical-issue'
]

const STATIC_WORKFLOW_PATHS=[
    'state',
    'action',
   
]

const STATIC_ACCESS_CONTROL_PATHS=[
    'permissions',
    "settings"
]

const STATIC_CONFIGURATION_PATHS=[
    'coder-quality-score',
    'group-configuration',
    'assignment-configuration'
]

const MainBreadcrumb = () => {
    const location = useLocation()
    const params = useParams()
    const [breadcrumbItems, setBreadcrumbItems] = useState([])
    

    useEffect(() => {
        const pathSegments = location.pathname.split('/').filter(Boolean)
        setBreadcrumbItems(pathSegments)
    }, [location])

    const renderBreadcrumbLink = (segment) => {
        const label = capitalizeFirstChar(segment.replaceAll('-', ' '))

        if (['setup', 'configuration', 'access-control'].includes(segment)) {
            return (
                <BreadcrumbLink to="#" className="hover:text-white cursor-text font-bold">
                    {label}
                </BreadcrumbLink>
            )
        }

        if (STATIC_SETUP_PATHS.includes(segment)) {
            return (
                <Link to={`/setup/${segment}`}>
                    <BreadcrumbLink to="#" className="hover:text-white hover:underline cursor-pointer font-bold">
                        {label}
                    </BreadcrumbLink>
                </Link>
            )
        }
        if (STATIC_CONFIGURATION_PATHS.includes(segment)) {
            return (
                <Link to={`/configuration/${segment}`}>
                    <BreadcrumbLink to="#" className="hover:text-white hover:underline cursor-pointer font-bold">
                        {label}
                    </BreadcrumbLink>
                </Link>
            )
        }

        if(STATIC_WORKFLOW_PATHS.includes(segment)){
            return (
                <Link to={`/workflow/${segment}`}>
                    <BreadcrumbLink to="#" className="hover:text-white hover:underline cursor-pointer font-bold">
                        {label}
                    </BreadcrumbLink>
                </Link>
            )
        }
        console.log("segment L ", segment)
        return (
            <Link to={`/${segment == 'workflow' ? 'workflow_' :  segment}`}>
                <BreadcrumbLink to="#" className="hover:text-white hover:underline cursor-pointer font-bold">
                    {label}
                </BreadcrumbLink>
            </Link>
        )
    }

    const renderBreadcrumbs = () => {
        const lastIndex = breadcrumbItems.length - 1
        if (breadcrumbItems.length === 0) {
            return (
                <BreadcrumbItem key="dashboard">
                    <BreadcrumbPage className="text-white font-bold">Dashboard</BreadcrumbPage>
                </BreadcrumbItem>
            )
        }

        return breadcrumbItems.map((segment, index) => {
            const isLast = index === lastIndex
            const label = capitalizeFirstChar(segment.replaceAll(/[-_]/g, ' '))
            const key = `${segment}-${index}`

            if (isLast) {
                const displayText = Object.keys(params).length > 0 ? decodeURI(segment) : label
                return (
                    <BreadcrumbItem key={key}>
                        <BreadcrumbPage className="text-white font-bold">{displayText}</BreadcrumbPage>
                    </BreadcrumbItem>
                )
            }

            return (
                <React.Fragment key={key}>
                    <BreadcrumbItem className="hidden md:block">{renderBreadcrumbLink(segment)}</BreadcrumbItem>
                    <BreadcrumbSeparator className="hidden md:block" />
                </React.Fragment>
            )
        })
    }

    return (
        <Breadcrumb>
            <BreadcrumbList className="text-white">{renderBreadcrumbs()}</BreadcrumbList>
        </Breadcrumb>
    )
}

export default MainBreadcrumb
